import useUser from './useUser';

export default function useUserRole() {
  const { user } = useUser();
  if (user) {
    if (user.roles && user.roles.length > 0) {
      const userRole: any = user?.roles.find((role: string) => role);
      return userRole;
    }
  } else {
    return null;
  }
}
